import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { ActivatedRoute } from '@angular/router';
import { Utils } from '../../util';

import { IncomeService, IncomeData, IncomedBill, IncomeBill, Income, FolioLog, IncomeId } from '../../services/income.service';
import { CustomerBillService, CustomerBillData, PrForBill, CreditNote, Incomed, CustomerBill, CustomerBillId } from '../../services/customer-bill.service';
import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { FiscalDataService } from '../../services/fiscal-data.service';
import { BankService, BankData } from '../../services/bank.service';

import { ISubscription, Subscription } from "rxjs/Subscription";
import { EmployeeId } from '../../services/employee.service';
import { FirestoreService } from '../../services/firestore/firestore.service';
import { Globals } from '../../globals';

@Component({
  selector: 'app-display-income',
  templateUrl: './display-income.component.html',
  styleUrls: ['./display-income.component.css']
})
export class DisplayIncomeComponent implements OnInit, OnDestroy {

  incomeId: string;
  customerId: string;
  fiscalDataId: string;
  customerName: string = '';
  fiscalDataName: string = '';
  empName: string = '';
  folioLogs: FolioLog[] = [];

  form: FormGroup;

  subs = [];

  constructor(
    private service: IncomeService,
    private incomeData: IncomeData,
    private customerBillService: CustomerBillService,
    private customerBillData: CustomerBillData,
    private customerService: CustomerSupplierService,
		private fiscalDataService: FiscalDataService,
    private bankService: BankService,
    private bankData: BankData,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private fsService: FirestoreService,
  ) {
    this.incomeId = activatedRoute.snapshot.paramMap.get('id');

    /* this.subs.push(
      this.customerBillService.getCustomerBills().subscribe(customerBills => {
        this.incomedBills = customerBills.map(customerBill => new IncomedBill(customerBill, this.incomeId) ).filter(bill => bill.lastAmount);
      })
    ); */
  }

  ngOnInit() {
    this.createForm();
    this.subs.push(
      this.service.getIncome(this.incomeId).subscribe(([{employeeObj=<EmployeeId>{}, ...income}]: (IncomeId & {[k: string]: any})[]) => {
        income.payMethod = this.incomeData.statusObjects[income.payMethod].name as any;
        income.totalAmount = income.amount + (income.extraAmount || 0);
        this.form.patchValue(income);
        this.selectedBankAccountNumber = income.bankObj.accountNumber;
        this.customerId = income.customerObj.id;
        this.customerName = income.customerObj.name;
        this.fiscalDataId = income.fiscalDataObj.id;
        this.fiscalDataName = income.fiscalDataObj.businessName;
        let {name='', lastName=''} = employeeObj;
        this.empName = `${name} ${lastName}`;
        this.folioLogs = income.folioLogs || [];
        console.log(income);
        this.getIncomeCustomerBills(income.bills.map(bill => bill.customerBillId));
      })
    );
  }
	ngOnDestroy() {
    this.subs.map((sub,index) => {
      this.subs[index].unsubscribe();
    });
  }

	onEdit() {
    //if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000);
		this.service.windowReplace('edit', `${this.incomeId}/${this.fiscalDataId}/${this.customerId}`);
	}

  createForm(){
    this.form = this.fb.group({
      folio: '',
      date: '',
      amount: '',
      extraAmount: '',
      totalAmount: '',
      payMethod: '',
      notes: ''
    });
  }

  money = Utils.money;

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 
  selectedBankAccountNumber: string = '';
  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA

  //////////////////////////////////////////////////////////////////////////////////////////////CUSTOMER BILL
  async getIncomeCustomerBills(billIds: string[]){
    let allBills: CustomerBillId[] = [];
    for(let billId of billIds){
      let billDoc = await this.fsService.docWithId<CustomerBillId>(`${Globals.CUSTOMER_BILL_COLLECTION}/${billId}`);
      allBills.push(billDoc);
    }
    this.incomedBills = allBills.map(customerBill => new IncomedBill(customerBill, this.incomeId) ).filter(bill => bill.lastAmount);

  }
  incomedBills: IncomedBill[] = [];
  //////////////////////////////////////////////////////////////////////////////////////////////CUSTOMER BILL
}